import React from 'react';
import { Box, Typography, InputBase } from '@mui/material';
import './filterField.scss';

interface OrderIdFilterFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const OrderIdFilterField: React.FC<OrderIdFilterFieldProps> = ({ value, onChange }) => {
  return (
    <Box className="filterField">
      <Typography className="filterFieldLabel">Order ID</Typography>
      <Box className="filterFieldInput orderField">
        <InputBase
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter Order ID"
          className="filterInputBase"
        />
      </Box>
    </Box>
  );
};

export default OrderIdFilterField;
